var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFastag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 60,
    viewBox: "0 0 80 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.719 16.599h-21.82v36.626h21.82V16.6z",
    fill: "url(#Fastag_svg__paint0_linear_336_4102)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.001 16.599h-21.82v36.626h21.82V16.6z",
    fill: "url(#Fastag_svg__paint1_linear_336_4102)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M47.001 16.599h-21.82v5.355h21.82v-5.355z",
    fill: "url(#Fastag_svg__paint2_linear_336_4102)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M37.14 21.96H26.842v10.3h10.3v-10.3z",
    fill: "url(#Fastag_svg__paint3_linear_336_4102)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.001 14.037H23.314v3.35h23.687v-3.35z",
    fill: "url(#Fastag_svg__paint4_linear_336_4102)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.96 14.037H47v3.35h15.958v-3.35z",
    fill: "url(#Fastag_svg__paint5_linear_336_4102)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61.719 24.51L47 21.955v-4.566H61.72v7.123z",
    fill: "url(#Fastag_svg__paint6_linear_336_4102)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M80 53.257H50.743v2.286H80v-2.286z",
    fill: "url(#Fastag_svg__paint7_linear_336_4102)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.272 58.323c16.214 0 29.359-.733 29.359-1.637S46.486 55.05 30.272 55.05c-16.214 0-29.358.732-29.358 1.636 0 .904 13.144 1.637 29.358 1.637z",
    fill: "url(#Fastag_svg__paint8_radial_336_4102)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M45.14 41.933s7.014.9 10.532 2.425c1.177.51 1.966 1.7 1.907 2.31l-.413 4.23a2.796 2.796 0 01-2.782 2.525H8.14l-.888-.663-2.74-1.126c-.808-.331-1.4-1.057-1.485-1.926-.16-1.616-.073-5.288.292-7.477l.038-.21c.097-.517.46-.945.949-1.14C9.37 38.862 11.742 35 20.326 35h10.152c5.2 0 14.663 6.933 14.663 6.933z",
    fill: "url(#Fastag_svg__paint9_linear_336_4102)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M55.355 51.866c0 2.806-1.767 5.08-3.947 5.08H48.74V46.787h2.668c2.18 0 3.947 2.274 3.947 5.08z",
    fill: "#000"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M48.74 56.946c2.18 0 3.947-2.274 3.947-5.08 0-2.805-1.767-5.079-3.947-5.079s-3.947 2.274-3.947 5.08c0 2.805 1.767 5.079 3.947 5.079z",
    fill: "url(#Fastag_svg__paint10_linear_336_4102)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.258 51.866c0 2.806-1.768 5.08-3.947 5.08h-2.668V46.787h2.668c2.18 0 3.947 2.274 3.947 5.08zM17.646 51.866c0 2.806-1.767 5.08-3.947 5.08H11.03V46.787H13.7c2.18 0 3.947 2.274 3.947 5.08z",
    fill: "#000"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M45.14 41.933S35.989 35 30.238 35h-8.082c2.026 0 3.688.702 4.565 1.525l3.964 5.408s8.91 1.63 12.537 3.858c.665.408.947.882.973 1.625l-.431 4.686s.05 1.32-1.448 1.32h12.068a2.797 2.797 0 002.783-2.524s.357-3.498.413-4.23c.056-.732-.972-1.965-2.439-2.526-3.646-1.394-10-2.209-10-2.209z",
    fill: "url(#Fastag_svg__paint11_linear_336_4102)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M32.064 41.933H13.398a8.477 8.477 0 01-2.804-.477l-2.192-.769a.353.353 0 01-.106-.607c1.223-1.002 4.638-3.266 8.266-4.038 2.582-.549 4.178-.425 7.035-.425 2.876.85 5.797 3.277 8.467 6.316z",
    fill: "#000"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M3.32 42.233l3.712 1.264c1.394.474 2.857.716 4.33.716h19.8s6.977.068 11.72 1.44c.781.227 1.312.952 1.312 1.765l-.552 6.007H8.14l-.887-.663-3.209-1.318a1.545 1.545 0 01-.944-1.188c-.376-2.426-.146-5.877.22-8.023z",
    fill: "url(#Fastag_svg__paint12_linear_336_4102)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M32.063 41.933h13.078c-3.64-2.856-7.858-5.158-11.485-6.328l-10.06.012c2.845.838 5.661 3.287 8.467 6.316z",
    fill: "url(#Fastag_svg__paint13_linear_336_4102)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M11.031 56.946c2.18 0 3.947-2.274 3.947-5.08 0-2.805-1.767-5.079-3.947-5.079s-3.947 2.274-3.947 5.08c0 2.805 1.767 5.079 3.947 5.079z",
    fill: "url(#Fastag_svg__paint14_linear_336_4102)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M10.892 55.048c1.256 0 2.273-1.425 2.273-3.181 0-1.757-1.017-3.181-2.273-3.181-1.255 0-2.273 1.424-2.273 3.18 0 1.757 1.018 3.182 2.273 3.182z",
    fill: "url(#Fastag_svg__paint15_linear_336_4102)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M10.892 53.733c.736 0 1.333-.835 1.333-1.865s-.597-1.865-1.333-1.865-1.333.835-1.333 1.865.597 1.865 1.333 1.865z",
    fill: "url(#Fastag_svg__paint16_linear_336_4102)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M36.643 56.946c2.18 0 3.947-2.274 3.947-5.08 0-2.805-1.767-5.079-3.947-5.079s-3.947 2.274-3.947 5.08c0 2.805 1.767 5.079 3.947 5.079z",
    fill: "url(#Fastag_svg__paint17_linear_336_4102)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M36.504 55.048c1.255 0 2.273-1.425 2.273-3.181 0-1.757-1.018-3.181-2.273-3.181-1.256 0-2.274 1.424-2.274 3.18 0 1.757 1.018 3.182 2.274 3.182z",
    fill: "url(#Fastag_svg__paint18_linear_336_4102)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M36.504 53.733c.736 0 1.333-.835 1.333-1.865s-.597-1.865-1.333-1.865-1.333.835-1.333 1.865.596 1.865 1.333 1.865z",
    fill: "url(#Fastag_svg__paint19_linear_336_4102)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M42.116 45.447s6.441.302 10.231.259c3.79-.043 4.516-.496 4.516-.496s.756.706.716 1.459l-.053.592s-.551.328-1.588.385c-.557.03-1.033-.01-1.373-.45-.164-.213-.672-.882-.672-.882s-1.792.084-4.222-.029c0 0-.724 1.117-1.337 1.405-.364.17-2.984.077-4.203-.118-1.583-.253-2.015-2.125-2.015-2.125z",
    fill: "#939393"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M22.637 44.212h1.849v.535a.462.462 0 01-.462.461H23.1a.462.462 0 01-.462-.461v-.535z",
    fill: "url(#Fastag_svg__paint20_linear_336_4102)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 44.212h1.622v.245a.194.194 0 01-.194.195h-1.233a.194.194 0 01-.195-.194v-.245z",
    fill: "url(#Fastag_svg__paint21_linear_336_4102)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M13.392 44.212h1.849v.535a.462.462 0 01-.462.461h-.926a.462.462 0 01-.461-.461v-.535z",
    fill: "url(#Fastag_svg__paint22_linear_336_4102)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M13.505 44.212h1.622v.245a.194.194 0 01-.194.195h-1.234a.194.194 0 01-.194-.194v-.245z",
    fill: "url(#Fastag_svg__paint23_linear_336_4102)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M29.979 42.264H27.38a.89.89 0 110-1.78h.918c.388 0 .765.134 1.067.38l1.318 1.07-.705.33z",
    fill: "url(#Fastag_svg__paint24_linear_336_4102)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M47.73 46.932c-1.832 0-3.99-.163-4.087-.178a.31.31 0 11.097-.614c.024.004 2.445.208 4.273.168.165 0 .314.132.317.304a.311.311 0 01-.304.317 13.75 13.75 0 01-.296.003z",
    fill: "url(#Fastag_svg__paint25_linear_336_4102)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M55.017 46.827a.31.31 0 01-.037-.62c.013 0 1.401-.05 2.289-.502.115.154.235.409.266.57-1.054.554-2.421.543-2.48.55a.321.321 0 01-.038.002z",
    fill: "url(#Fastag_svg__paint26_linear_336_4102)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M3.611 41.429l.653 1.137s.014.649-1.092.665l.094-1.072s.067-.433.345-.73z",
    fill: "url(#Fastag_svg__paint27_linear_336_4102)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M33.87 44.732h-.444a.26.26 0 100 .52h.444a.26.26 0 100-.52z",
    fill: "url(#Fastag_svg__paint28_linear_336_4102)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M20.41 53.423h-.155v-8.46c0-.505.06-1.01.177-1.5l.367-1.53h.16l-.376 1.566a6.293 6.293 0 00-.173 1.464v8.46z",
    fill: "url(#Fastag_svg__paint29_linear_336_4102)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M73.146 35.16h-8.219v18.065h8.219V35.16z",
    fill: "url(#Fastag_svg__paint30_linear_336_4102)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M77.835 26.991h-.58v26.233h.58V26.991z",
    fill: "#939393"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M77.255 53.222h-4.11V35.157l4.11-3.204v21.27z",
    fill: "url(#Fastag_svg__paint31_linear_336_4102)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M77.255 31.953h-8.218l-4.11 3.204h8.219l4.109-3.204z",
    fill: "url(#Fastag_svg__paint32_linear_336_4102)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M68.738 37c-.705 0-1.277.572-1.277 1.278v1.724a1.277 1.277 0 102.553 0v-1.724c0-.706-.57-1.277-1.276-1.277z",
    fill: "url(#Fastag_svg__paint33_linear_336_4102)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M69.86 38.283a1.122 1.122 0 00-2.244 0v1.712a1.122 1.122 0 002.244 0v-1.712z",
    fill: "url(#Fastag_svg__paint34_linear_336_4102)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M68.099 40.329L46.848 28.076a.443.443 0 01-.162-.603l.864-1.498a.443.443 0 01.603-.163l20.49 11.814a.544.544 0 01.272.471v1.76c0 .419-.453.68-.816.472z",
    fill: "url(#Fastag_svg__paint35_linear_336_4102)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M48.144 25.778a.45.45 0 00-.615.165l-.865 1.498a.45.45 0 00.78.45l.864-1.498a.45.45 0 00-.164-.615z",
    fill: "url(#Fastag_svg__paint36_linear_336_4102)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M53.765 32.057l-.7-.404v-3.016l.7.404v3.016zm2.065-1.826l-.7-.404v3.017l.7.403v-3.016zm-6.894-.959l.7.404V26.66l-.7-.404v3.016zm2.765-1.422l-.7-.403v3.016l.7.403V27.85zm6.194 3.571l-.7-.403v3.016l.7.404V31.42zm2.064 1.19l-.7-.403v3.016l.7.404v-3.016zm8.26 4.763l-.7-.404v3.016l.7.404v-3.017zm-2.065-1.191l-.7-.404v3.017l.7.403v-3.016zm-2.065-1.19l-.7-.404v3.016l.7.404v-3.016zm-2.065-1.19l-.7-.404v3.016l.7.404v-3.017z",
    fill: "url(#Fastag_svg__paint37_linear_336_4102)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M77.255 26.991h-8.218v4.964h8.218V26.99z",
    fill: "url(#Fastag_svg__paint38_linear_336_4102)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M76.58 27.666h-6.886v3.568h6.885v-3.568z",
    fill: "url(#Fastag_svg__paint39_linear_336_4102)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.587 30.015v-1.231l.29-.29h.827l.28.28v.204h-.249v-.116l-.15-.15h-.59l-.16.16v1.055l.16.16h.585l.158-.158v-.372h-.401v-.217h.646v.675l-.29.29h-.816l-.29-.29zM73.293 30.015v-1.231l.29-.29h.853l.29.29v1.23l-.29.29h-.853l-.29-.29zm1.024.072l.16-.16v-1.055l-.16-.16h-.615l-.16.16v1.055l.16.16h.615z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fastag_svg__paint0_linear_336_4102",
    x1: 64.973,
    y1: 8.543,
    x2: 35.317,
    y2: 63.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.784,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFCFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fastag_svg__paint1_linear_336_4102",
    x1: 36.092,
    y1: 13.64,
    x2: 36.092,
    y2: 52.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFCFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fastag_svg__paint2_linear_336_4102",
    x1: 36.092,
    y1: 17.117,
    x2: 36.092,
    y2: 29.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E4E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fastag_svg__paint3_linear_336_4102",
    x1: 31.991,
    y1: 22.958,
    x2: 31.991,
    y2: 32.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBDBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fastag_svg__paint4_linear_336_4102",
    x1: 2.932,
    y1: 32.2,
    x2: 73.337,
    y2: -47.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.784,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFCFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fastag_svg__paint5_linear_336_4102",
    x1: 33.27,
    y1: 32.2,
    x2: 101.577,
    y2: -19.674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.784,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFCFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fastag_svg__paint6_linear_336_4102",
    x1: 53.099,
    y1: 15.467,
    x2: 63.796,
    y2: 51.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.784,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFCFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fastag_svg__paint7_linear_336_4102",
    x1: 62.865,
    y1: 52.64,
    x2: 63.468,
    y2: 65.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.784,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFCFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fastag_svg__paint9_linear_336_4102",
    x1: 39.478,
    y1: 37.419,
    x2: 29.541,
    y2: 47.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E7E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fastag_svg__paint10_linear_336_4102",
    x1: 48.74,
    y1: 47.496,
    x2: 48.74,
    y2: 57.245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fastag_svg__paint11_linear_336_4102",
    x1: 39.88,
    y1: 36.474,
    x2: 39.834,
    y2: 53.539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E9EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#DCDDDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.692,
    stopColor: "#CACBCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779,
    stopColor: "#BFC1C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#BCBEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#828282"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fastag_svg__paint12_linear_336_4102",
    x1: 23.665,
    y1: 42.711,
    x2: 23.395,
    y2: 53.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297,
    stopColor: "#A8A7AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759,
    stopColor: "#BCBEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#828282"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fastag_svg__paint13_linear_336_4102",
    x1: 36.562,
    y1: 34.852,
    x2: 31.519,
    y2: 43.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338,
    stopColor: "#6D6E71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fastag_svg__paint14_linear_336_4102",
    x1: 11.031,
    y1: 47.496,
    x2: 11.031,
    y2: 57.245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fastag_svg__paint15_linear_336_4102",
    x1: 11.703,
    y1: 48.779,
    x2: 10.25,
    y2: 54.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E7E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fastag_svg__paint16_linear_336_4102",
    x1: 11.368,
    y1: 50.057,
    x2: 10.516,
    y2: 53.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E7E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fastag_svg__paint17_linear_336_4102",
    x1: 36.643,
    y1: 47.496,
    x2: 36.643,
    y2: 57.245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fastag_svg__paint18_linear_336_4102",
    x1: 37.315,
    y1: 48.779,
    x2: 35.861,
    y2: 54.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E7E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fastag_svg__paint19_linear_336_4102",
    x1: 36.979,
    y1: 50.057,
    x2: 36.127,
    y2: 53.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E7E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fastag_svg__paint20_linear_336_4102",
    x1: 23.561,
    y1: 44.079,
    x2: 23.561,
    y2: 44.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDDFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fastag_svg__paint21_linear_336_4102",
    x1: 22.505,
    y1: 44.494,
    x2: 24.588,
    y2: 44.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E7E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fastag_svg__paint22_linear_336_4102",
    x1: 14.316,
    y1: 44.08,
    x2: 14.316,
    y2: 44.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDDFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fastag_svg__paint23_linear_336_4102",
    x1: 13.26,
    y1: 44.494,
    x2: 15.343,
    y2: 44.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E7E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fastag_svg__paint24_linear_336_4102",
    x1: 25.873,
    y1: 41.555,
    x2: 31.162,
    y2: 41.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDCDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E7E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fastag_svg__paint25_linear_336_4102",
    x1: 43.381,
    y1: 46.534,
    x2: 48.33,
    y2: 46.534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#939393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.104,
    stopColor: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.376,
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fastag_svg__paint26_linear_336_4102",
    x1: 57.531,
    y1: 45.625,
    x2: 56.705,
    y2: 46.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E7E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fastag_svg__paint27_linear_336_4102",
    x1: 3.172,
    y1: 42.33,
    x2: 4.264,
    y2: 42.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA7E78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.032,
    stopColor: "#EA807A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    stopColor: "#EA8F8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.647,
    stopColor: "#EA9897"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#EA9C9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fastag_svg__paint28_linear_336_4102",
    x1: 33.648,
    y1: 45.264,
    x2: 33.648,
    y2: 44.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA7E78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.032,
    stopColor: "#EA807A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    stopColor: "#EA8F8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.647,
    stopColor: "#EA9897"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#EA9C9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fastag_svg__paint29_linear_336_4102",
    x1: 20.607,
    y1: 62.887,
    x2: 20.607,
    y2: 37.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E7E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fastag_svg__paint30_linear_336_4102",
    x1: 61.306,
    y1: 52.427,
    x2: 81.725,
    y2: 30.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#939393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.104,
    stopColor: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.376,
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fastag_svg__paint31_linear_336_4102",
    x1: 68.465,
    y1: 51.364,
    x2: 88.367,
    y2: 30.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#939393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.104,
    stopColor: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.376,
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fastag_svg__paint32_linear_336_4102",
    x1: 61.278,
    y1: 52.354,
    x2: 73.285,
    y2: 29.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#939393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.104,
    stopColor: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.376,
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fastag_svg__paint33_linear_336_4102",
    x1: 68.738,
    y1: 41.889,
    x2: 68.738,
    y2: 34.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#939393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.104,
    stopColor: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.376,
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fastag_svg__paint34_linear_336_4102",
    x1: 64.42,
    y1: 47.41,
    x2: 69.703,
    y2: 37.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fastag_svg__paint35_linear_336_4102",
    x1: 57.367,
    y1: 34.46,
    x2: 59.381,
    y2: 31.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#939393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.219,
    stopColor: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fastag_svg__paint36_linear_336_4102",
    x1: 47.256,
    y1: 28.324,
    x2: 48.133,
    y2: 22.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E7E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fastag_svg__paint37_linear_336_4102",
    x1: 57.556,
    y1: 35.16,
    x2: 59.165,
    y2: 32.264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.236,
    stopColor: "#A06758"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.365,
    stopColor: "#B47466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644,
    stopColor: "#DD8C83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#F59C94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#FFA29B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fastag_svg__paint38_linear_336_4102",
    x1: 72.576,
    y1: 32.951,
    x2: 74.744,
    y2: 19.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.288,
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.818,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fastag_svg__paint39_linear_336_4102",
    x1: 73.137,
    y1: 31.935,
    x2: 73.137,
    y2: 27.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1554F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.135,
    stopColor: "#CB6A61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.334,
    stopColor: "#D78477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541,
    stopColor: "#E09687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757,
    stopColor: "#E5A190"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#E7A594"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Fastag_svg__paint8_radial_336_4102",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(29.0252 0 0 1.65438 30.273 56.684)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042",
    stopOpacity: 0
  })))));
}
export default SvgFastag;